let __priority = 9;

export const getPriority = () => __priority;
export const setPriority = (p: number) => {
  __priority = p;
};
